import EnterpriseLibrarySidebar from "../../components/sidebars/EnterpriseLibrarySidebar"
import PageSidebarContent from "../../components/sidebars/PageSidebarContent"
import FormBuilder from "../../pages/Form/"
import styles from "../../styles/Fields-Library.module.css"

export default function EnterpriseProfile() {
  return (
    <div className="page-fields">
      <PageSidebarContent>
        <EnterpriseLibrarySidebar />
      </PageSidebarContent>
      <div className="main-content">
        <h1 className={styles.title}>
          Enterprise <span>Profile</span>
        </h1>
        <div className={styles.description}>
            Administrators can configure enterprise features and add new services to their RecoveryLink application for use by member organizations.
        </div>
        <div className={styles.form}>
          <FormBuilder />
        </div> 
      </div>  
    </div>
  )
}
